import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "menupro_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      // do not force-logout here; let AuthContext handle
    }
    return Promise.reject(error);
  }
);

export function apiErrorMessage(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Erro inesperado";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  }
  if (typeof d === "object" && typeof d.msg === "string") return d.msg;
  return String(d);
}

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const blob = new Blob([res.data]);
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
